import { SDKConfiguration } from "@/inference/setup/config";
import { UAParser, IResult } from "@ua-parser-js/pro-business";
import { iPhoneModels } from "./constants/iphone-gpu-model-mapping";

export async function getUaParserWithAppleDevicesModels(): Promise<IResult> {
  const uaParsed = (await UAParser(
    navigator.userAgent,
  ).withClientHints()) as unknown as IResult;

  const isApple = uaParsed.device.vendor?.toLowerCase() === "apple";
  const isiPhone = (uaParsed.device?.model || "").toLowerCase() === "iphone";

  const gpuFamily = window.helium.attributes.persona.primary.GPUFamily;

  if (!isApple || !gpuFamily) {
    return uaParsed;
  }

  if (uaParsed.device.model === "Macintosh") {
    uaParsed.device.model = gpuFamily?.toLowerCase().replace("gpu", "") || "";

    return uaParsed;
  }

  if (!isiPhone) {
    return uaParsed;
  }

  const viewportString = `${window.innerWidth * window.devicePixelRatio}x${window.innerHeight * window.devicePixelRatio}`;
  const devicePixelRatio = window.devicePixelRatio;

  iPhoneModels.forEach((iphoneModel) => {
    if (!(gpuFamily || "").toLowerCase().includes(iphoneModel.gpu)) return;

    const firstViewport = Object.keys(iphoneModel.viewports)[0];

    uaParsed.device.model =
      iphoneModel.viewports[firstViewport].devicePixelRatios["3"].models[0];

    const viewport = iphoneModel.viewports[viewportString];

    if (!viewport) {
      return;
    }

    const devicePixelRatioModel = viewport.devicePixelRatios[devicePixelRatio];

    if (!devicePixelRatioModel) {
      return uaParsed;
    }

    uaParsed.device.model =
      viewport.devicePixelRatios[devicePixelRatio].models[0];
  });

  return uaParsed;
}

export async function getUserDeviceInfo() {
  const res = (await fetch(
    SDKConfiguration.DEVICE_INFO +
      "?model=" +
      window.helium.attributes.persona.primary.device.model,
  ).then((e) => e.json())) as {
    weather: string;
    isp: string;
    city: string;
    country: string;
    cityTier: string;
    deviceModel: {
      modelNumber: string;
      manufacturer: string;
      tier: number;
      recency: number;
      full_name: string;
    };
  };

  return { ...res, isp: resolveISP(res.isp) };
}

function resolveISP(isp: string) {
  if (!isp) return isp;

  const supportedISP = [
    "Airtel",
    "Jio",
    "BSNL",
    "ACT Fibernet",
    "Tata Play Fiber",
  ];

  for (const supported of supportedISP) {
    if (isp.toLowerCase().includes(supported.toLowerCase())) {
      return supported;
    }
  }

  return isp;
}
